import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router';
import PrivateRoute from 'components/PrivateRoute';
import Notifications from 'components/Notifications';
import Spinner from "components/Spinner";

import AuthPage from 'pages/AuthPage';
import HomePage from 'pages/HomePage';
import IntroPage from "pages/IntroPage";

import LandingPage from 'pages/LandingPage';

import { Actions } from 'reducers/app';
import { getTips } from 'api/app';

interface IProps {
  tipsSave: (tips: any) => void;
}

const App: React.SFC<IProps> = ({
  tipsSave,
}) => {
  useEffect(() => {
    getTips().then((response: any) => {
      if (response.success) {
        tipsSave(response.data);
      }
    });
  }, []);

  return (
    <React.Fragment>
      <Switch>
        <Redirect exact={true} from="/" to="/home" />
        <Route path={'/auth'} component={AuthPage} />
        <PrivateRoute path={'/home'} component={HomePage} />
        <PrivateRoute path={'/intro'} component={IntroPage} />
        <Route path={'/landing'} component={LandingPage} />
        <Route path={'/welcomePage'} component={LandingPage} />
      </Switch>
      <Spinner />
      <Notifications />
    </React.Fragment>
  );
};

const actions = {
  tipsSave: Actions.tipsSave,
};

export default connect(null, actions)(App);
